var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-portal-notification"},[(_vm.isvalid)?_c('span',[_vm._v("This portal was shared with you by "+_vm._s(_vm.name)+".  Please keep this link confidential as anyone with it may access this information.")]):_c('span',[_vm._v("You do not have access to this portal. Please contact the patient to request access.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }